import { render, staticRenderFns } from "./MatchConsentGuardStep.vue?vue&type=template&id=40c60bf8"
import script from "./MatchConsentGuardStep.vue?vue&type=script&lang=js"
export * from "./MatchConsentGuardStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports